var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Baseline',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{staticClass:"d-flex justify-center",attrs:{"cols":"12"}},[_c('v-progress-circular',{attrs:{"size":200,"width":8,"color":"primary","indeterminate":""}})],1)],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }